;(function ($) {
  "use strict"
  $(function () {
    // Меняем ширину блока с инфо о заказах
    $(document)
      .find(".order-history")
      .on("click", ".order-history__toggle", function () {
        if ($(document).find(".x-show-company").length) {
          $(document).find(".order-history").toggleClass("large-24").toggleClass("large-12")
          $(document).find(".order-history").toggleClass("show-company")
          $(document).find(".x-show-company__6").toggleClass("large-6").toggleClass("medium-6")
          $(document).find(".x-show-company__5").toggleClass("large-5").toggleClass("medium-5")
          $(document).find(".x-show-company__4").toggleClass("large-4").toggleClass("medium-4")
        } else {
          $(document).find(".order-history").toggleClass("large-24").toggleClass("large-18")
        }
        $(document).find(".order-history__toggle").toggleClass("change-toggle-text")
        $(document).find(".order-detail").toggleClass("order-detail_show")
        $(document).find(".order-category").toggleClass("order-category_small")
        $(document).find(".order-open__title").toggleClass("order-open__title_small")
        $(document).find(".order-open__list").toggleClass("order-open__list_small")
        $(document).find(".order-company").toggleClass("hide")
        $(document).find(".x-order-deployed").toggleClass("hide")
        $(document).find(".table-order").toggleClass("table-order_small")
      })

    //Аккордеон для раскрытия детальной информации о заказах
    var acc = document.getElementsByClassName("order-detail_show")
    var i

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("js-active")

        var panel = this.nextElementSibling
        if (panel.style.display === "block") {
          panel.style.display = "none"
        } else {
          panel.style.display = "block"
        }
      })
    }
  })
})(jQuery)
